import { useCustomForm } from "common/hooks/src/api/useCustomForm";
import { Button } from "components/button";
import { CardWithTitle } from "components/card/CardWithTitle";
import { InputField, ResizableInputField } from "components/fields/InputField";
import { useCreateFamily } from "modules/family/api";
import { CreateFamilyPayload } from "modules/family/types/family.interface";
import { FormEvent } from "react";
import "react-datepicker/dist/react-datepicker.css";

const CreateFamily = () => {
  const { mutate } = useCreateFamily();
  const { formValues, setFormValues } = useCustomForm<CreateFamilyPayload>({
    name: "",
    description: "",
  });

  const isSubmitDisabled = formValues.name === "";

  const handleSubmit = (e: FormEvent) => {
    if (isSubmitDisabled) return;

    e.preventDefault();

    mutate({
      ...formValues,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <CardWithTitle title="Information de la famille">
        <div className="grid grid-cols-1 gap-5">
          <InputField
            autoFocus
            variant="auth"
            extra="mb-3"
            label="Nom de la famille*"
            placeholder="Famille Dupont"
            id="name"
            type="text"
            value={formValues.name}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                name: e.target.value,
              })
            }
          />
          <ResizableInputField
            variant="auth"
            extra="mb-3"
            label="Description"
            placeholder="Description de la famille..."
            id="description"
            value={formValues.description}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                description: e.target.value,
              })
            }
          />
        </div>
      </CardWithTitle>
      <div className="mt-2 flex w-full justify-end">
        <div className="w-full max-w-xs">
          <Button onClick={handleSubmit} disabled={isSubmitDisabled}>
            Créer la famille
          </Button>
        </div>
      </div>
    </form>
  );
};

export default CreateFamily;
